import React from 'react'
import MenuItem from 'material-ui/MenuItem'

const buildMenuItems = (resource) => {
  return [
    <MenuItem primaryText='Edit' key='edit' value={`/write-now/programs/${resource.id}/edit`} />,
    <MenuItem primaryText='Sessions' key='sessions' value={`/write-now/sessions?filters[program_id]=${resource.id}`} />,
    <MenuItem primaryText='Questions' key='questions' value={`/write-now/program_questions?filters[program_id]=${resource.id}`} />
  ]
}

export default buildMenuItems
